<template>
  <v-layout align-center column style="margin-top:100px;">
    <p class="Section-Title">See Available Position</p>
    <v-row>
      <v-col>
        <v-skeleton-loader
          type="image"
          class="Career-Image"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/TentangKami/Career-Image.png"
          srcset="
            ../../assets/TentangKami/Career-Image@2x.png 2x,
            ../../assets/TentangKami/Career-Image@3x.png 3x
          "
          @load="onImgLoad"
          class="Career-Image"
        />
      </v-col>
      <v-col>
        <div class="box">
          <p class="Desc">
            Hola, we're recruiting good people to fill several position, send ur
            latest <span class="text-style-1">CV and Portfolio </span>to
            <span class="text-style-1">join@dompetkilat.co.id</span>
          </p>
          <p
            class="Web-Developer"
            style="cursor: pointer"
            @click="toRecruitment"
          >
            <img class="Ellipse Point" />Product Owner
          </p>
          <p
            class="Web-Developer"
            style="cursor: pointer"
            @click="toRecruitment"
          >
            <img class="Ellipse Point" />Risk and Compliance Manager
          </p>
          <p
            class="Web-Developer"
            style="cursor: pointer"
            @click="toRecruitment"
          >
            <img class="Ellipse Point" />Data Engineer
          </p>
          <p
            class="Web-Developer"
            style="cursor: pointer"
            @click="toRecruitment"
          >
            <img class="Ellipse Point" />Backend Developer
          </p>
        </div>
      </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
    toRecruitment() {
      window.location =
        "https://www.linkedin.com/jobs/view/2493131587/?refId=5z0n8buARhC5yrT%2Bf%2F2iuQ%3D%3D";
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 277px;
  height: 30px;
  flex-grow: 0;
  margin: 0px 309px 20px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  width: 514px;
  height: 48px;
  flex-grow: 0;
  margin: 0 0 16px;
  font-family: Inter;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Career-Image {
  width: 361px;
  height: 240px;
  flex-grow: 0;
  margin: 60px 20px 0 0;
  object-fit: contain;
}
.Client-Representative {
  width: 482px;
  height: 22px;
  flex-grow: 0;
  margin: 0 0 0 8px;
  font-family: Sora;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Point {
  width: 494px;
  height: 22px;
  flex-grow: 0;
  margin: 16px 0 8px 20px;
}
.Web-Developer {
  width: 482px;
  height: 22px;
  flex-grow: 0;
  margin: 0 0 0 8px;
  font-family: Sora;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Ellipse {
  width: 4px;
  height: 4px;
  flex-grow: 0;
  margin: auto 8px 4px 0;
  background-color: #252525;
}
.box {
  margin-top: 15%;
}
@media screen and (max-width: 1200px) {
  .Section-Title {
    width: 277px;
    height: 30px;
    flex-grow: 0;
    margin: 50px 309px 20px;
    font-family: Sora;
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
  .Desc {
    width: 514px;
    height: 48px;
    flex-grow: 0;
    margin: 0 0 16px;
    font-family: Inter;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }

  .Desc .text-style-1 {
    font-weight: bold;
  }
  .Career-Image {
    width: 311px;
    height: 190px;
    flex-grow: 0;
    margin: 60px 20px 0 0;
    object-fit: contain;
  }
  .Client-Representative {
    width: 482px;
    height: 22px;
    flex-grow: 0;
    margin: 0 0 0 8px;
    font-family: Sora;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .Point {
    width: 494px;
    height: 22px;
    flex-grow: 0;
    margin: 16px 0 8px 20px;
  }
  .Web-Developer {
    width: 482px;
    height: 22px;
    flex-grow: 0;
    margin: 0 0 0 8px;
    font-family: Sora;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .Ellipse {
    width: 4px;
    height: 4px;
    flex-grow: 0;
    margin: auto 8px 4px 0;
    background-color: #252525;
  }
}
</style>
